import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import React from "react";
import PipeCard from "../../../pipe-common/PipeCard";
import {formatToExponential} from "../../../../helpers/NumberHelper";

const defaultIndicators = {
    global: {
        state: "UNAVAILABLE",
        klyDelayRemainingTime: "---",
        pulseRepetitionFrequency: "---",
        voltageSetValue: "---",
        klyFilamentCurrentSetValue: "---",
        pulseWidthSetValue: "---",
        klyFilamentCurrent: "---",
        klyFilamentVoltage: "---",
        tankDigiCurrentTransformer: "---",
        tankDigiCapacitiveVoltageDivider: "---",
        tankDigiFullWidthHalfMaximum: "---",
        tankOilTemperature: "---",
        tankOilLevel: "---",
        ccpsFlow: "---",
        suFlow: "---"
    },
    ccps: {}
};

export default function ScandinovaK1ReadBack({pipe, data}) {
    const indicators = data
        ? {
            global: data["global"] ? {
                state: data["global"]["state"] || defaultIndicators.global.state,
                pulseRepetitionFrequency: data["global"]["pulse_repetition_frequency"] || defaultIndicators.global.pulseRepetitionFrequency,
                klyFilamentCurrentSetValue: data["global"]["kly_filament_current_set_value"] || defaultIndicators.global.klyFilamentCurrentSetValue,
                pulseWidthSetValue: data["global"]["pulse_width_set_value"] || defaultIndicators.global.pulseWidthSetValue,
                klyFilamentCurrent: data["global"]["kly_filament_current"] || defaultIndicators.global.klyFilamentCurrent,
                klyFilamentVoltage: data["global"]["kly_filament_voltage"] || defaultIndicators.global.klyFilamentVoltage,
                tankDigiCurrentTransformer: data["global"]["tank_digi_current_transformer"] || defaultIndicators.global.tankDigiCurrentTransformer,
                tankDigiCapacitiveVoltageDivider: data["global"]["tank_digi_capacitive_voltage_divider"] || defaultIndicators.global.tankDigiCapacitiveVoltageDivider,
                tankDigiFullWidthHalfMaximum: data["global"]["tank_digi_full_width_half_maximum"] || defaultIndicators.global.tankDigiFullWidthHalfMaximum,
                tankOilTemperature: data["global"]["tank_oil_temperature"] || defaultIndicators.global.tankOilTemperature,
                tankOilLevel: data["global"]["tank_oil_level"] || defaultIndicators.global.tankOilLevel,
                ccpsFlow: data["global"]["ccps_flow"] || defaultIndicators.global.ccpsFlow,
                suFlow: data["global"]["su_flow"] || defaultIndicators.global.suFlow,
            } : defaultIndicators.global,
            ccps: data["ccps"] || defaultIndicators.ccps
        } : defaultIndicators;

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"row"} justify={"center"} alignItems={"center"} spacing={2}>
                    <Grid item>
                        <TextField
                            id="state"
                            label="State"
                            value={indicators.global.state}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="pulse-repetition-frequency"
                            label="TRIG&INT PRF"
                            value={formatToExponential(indicators.global.pulseRepetitionFrequency)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="kly-filament-current-set-value"
                            label="KLY PFS Current [SET]"
                            value={formatToExponential(indicators.global.klyFilamentCurrentSetValue)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="pulse-width-set-value"
                            label="SWITCH Pulse Width [SET]"
                            value={formatToExponential(indicators.global.pulseWidthSetValue)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="kly-filament-current"
                            label="KLY FPS Current"
                            value={formatToExponential(indicators.global.klyFilamentCurrent)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="kly-filament-voltage"
                            label="KLY FPS Voltage"
                            value={formatToExponential(indicators.global.klyFilamentVoltage)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="tank-digi-current-transformer"
                            label="TANK DIGI Current"
                            value={formatToExponential(indicators.global.tankDigiCurrentTransformer)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="tank-digi-capacitive-voltage-divider"
                            label="TANK DIGI CVD"
                            value={formatToExponential(indicators.global.tankDigiCapacitiveVoltageDivider)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="tank-digi-full-width-half-maximum"
                            label="TANK DIGI FWHM"
                            value={formatToExponential(indicators.global.tankDigiFullWidthHalfMaximum)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="tank-oil-temperature"
                            label="TANK Oil Temp"
                            value={formatToExponential(indicators.global.tankOilTemperature)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="ccps-flow"
                            label="COOL CCPS Flow"
                            value={formatToExponential(indicators.global.ccpsFlow)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            id="su-flow"
                            label="COOL SU Flow"
                            value={formatToExponential(indicators.global.suFlow)}
                            inputProps={{
                                readOnly: true,
                                style: {textAlign: "center"}
                            }}
                        />
                    </Grid>
                    {
                        Object.keys(indicators.ccps).map(key => {
                            const cpps = indicators.ccps[key];

                            return (
                                <Grid key={`scandinova-k1-cpps-${pipe.id}-${key}`} item>
                                    <TextField
                                        id="cpps-voltage"
                                        label={`CCPS Voltage [Unit ${key}]`}
                                        value={formatToExponential(cpps["voltage"])}
                                        inputProps={{
                                            readOnly: true,
                                            style: {textAlign: "center"}
                                        }}
                                    />
                                </Grid>
                            );
                        })
                    }
                </Grid>
            }
        />
    );
}